export default __webpack_public_path__ + "static/media/image_banner.024ae0c9.png";